function initAccountModal() {
  const tabButtons = document.querySelectorAll('.account-modal__tab-button');

  initModalEvents(tabButtons);
  initTabSwitchEvents(tabButtons);
}

function initModalEvents(tabButtons) {
  const accountModalDialog = document.querySelector('.account-modal');
  const accountModalCloseTrigger = document.querySelector('.account-modal__close');
  const loginButton = document.querySelector('.login-button');
  const registerButton = document.querySelector('.register-button');

  // loginButton.addEventListener('click', () => {
  //   openModal(accountModalDialog);
  //   switchTab('login', tabButtons);
  // });

  // registerButton.addEventListener('click', () => {
  //   openModal(accountModalDialog);
  //   switchTab('register', tabButtons);
  // });

  accountModalCloseTrigger.addEventListener('click', () => {
    closeModal(accountModalDialog);
  });

  accountModalDialog.addEventListener('click', (e) => {
    if(e.target !== accountModalDialog) return;
    closeModal(accountModalDialog);
  });
}

function initTabSwitchEvents(tabButtons) {
  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tabName = button.dataset.tab;

      switchTab(tabName, tabButtons);
    });
  });
}

function switchTab(name, buttons) {
  const tabs = document.querySelectorAll('.account-modal__tab');

  tabs.forEach((tab) => {
    const tabName = tab.id;
    tab.classList.toggle('active', (name === tabName));
  });

  buttons.forEach((button) => {
    const tabName = button.dataset.tab;
    button.classList.toggle('active', (name === tabName));
    button.ariaSelected = (name === tabName);
  });
}

function openModal(modalElement) {
  modalElement.showModal()
}

function closeModal(modalElement) {
  modalElement.close();
}

window.onload = initAccountModal();
